/**
 * English UI strings for shared components. Keys are shared with es.ts.
 *
 * Only interface chrome lives here. Compliance wording (licensing scope,
 * disclosures, consent) is NEVER stored in this file — it comes from
 * src/lib/legal/* so a legal change cannot go out of sync between languages.
 */
export const en = {
  "nav.language": "Language",
  "nav.english": "English",
  "nav.spanish": "Español",
  "nav.switchToSpanish": "Ver esta página en español",
  "nav.switchToEnglish": "View this page in English",
  "nav.startMyApproval": "Start My Approval",
  "nav.call": "Call",
  "nav.menu": "Menu",
  "nav.toggleMenu": "Toggle menu",
  "nav.home": "Home",
  "nav.seeAll": "See all",
  "nav.mortgageLoans": "Mortgage Loans",
  "nav.investorJourney": "Investor Journey",
  "nav.whereWeLend": "Where We Lend",
  "nav.whereWeLendCta": "Counties & markets we serve",
  "nav.statesWeLendIn": "States we lend in",
  "nav.licensingNote": "Licensed in FL & CO · business-purpose elsewhere",
  "nav.calculators": "Calculators",
  "nav.resources": "Resources",
  "nav.businessSetup": "Business Setup",
  "nav.blog": "Blog",
  "nav.partners": "Partners",
  "nav.about": "About",
  "nav.contact": "Contact",
  "nav.dscrPrograms": "DSCR Programs",
  "nav.loanOptionsByLocation": "Loan options by location",
  "nav.states": "States",
  "nav.allStatesCounties": "All states & counties we serve",

  "common.readMore": "Read more",
  "common.viewAll": "View all",
  "common.programs": "programs",
  "common.state": "State",
  "common.city": "City",
  "common.county": "County",
  "common.updated": "Last updated",
  "common.published": "Published",
  "common.reviewed": "Reviewed",
  "common.source": "Source",
  "common.educationalOnly": "Educational information only",
  "common.loading": "Loading…",
  "common.error": "Something went wrong",
  "common.close": "Close",
  "common.next": "Next",
  "common.back": "Back",
  "common.submit": "Submit",
  "common.optional": "Optional",
  "common.required": "Required",

  "cta.startApplication": "Start your full application",
  "cta.seeTodaysRates": "See Today's Rates",
  "cta.talkToUs": "Talk to a licensed loan officer",
  "cta.getYourRateQuote": "Get Your Personalized Rate Quote",
  "cta.checkYourScenario": "Check Your Scenario",

  "form.firstName": "First name",
  "form.lastName": "Last name",
  "form.email": "Email",
  "form.phone": "Phone",
  "form.message": "Message",
  "form.submit": "Submit",
  "form.submitting": "Sending…",
  "form.required": "Required",
  "form.recordInterest": "Record my interest",
  "form.preferredLanguage": "Preferred language",
  "form.preferredLanguageEnglish": "English",
  "form.preferredLanguageSpanish": "Spanish",

  "newsletter.title": "Investor lending update",
  "newsletter.body": "Rate trends, program updates and local market notes — one email a month.",
  "newsletter.emailPlaceholder": "Enter your email",
  "newsletter.subscribe": "Subscribe",

  "toc.title": "On this page",
  "quickAnswer.title": "Quick answer",
  "tldr.title": "TL;DR",

  "ai.title": "Ask SAM AI",
  "ai.placeholder": "Ask about DSCR loans…",
  "ai.popular": "Popular on this page",
  "ai.disclaimer":
    "Answers are informational, generated from published program rules, and are not a loan approval or a commitment to lend.",

  "translation.notice":
    "This page is a Spanish translation provided for convenience. Loan documents, disclosures and the mortgage application process are provided in English.",
} as const;

export type UiKey = keyof typeof en;
